import React, { useEffect } from "react";
import NonH2kParamTooltip from "components/NonH2kParamTooltip";
import classes from "./style.module.scss";
import sharedClasses from "../style.module.scss";
import Check from "assets/images/icons/Check.svg";

export default ({
    input = {},
    hideLabel = false,
    label = "",
    name,
    className,
    disabled,
    large,
    compact,
    noPadding,
    inlineRow = false,
    style = {},
    image,
    nonH2kParam = "",
    reset = false,
}) => {
    const { value, onChange } = input;

    const classNamesList = [
        classes.checkboxWrapper,
        inlineRow ? classes.inlineRow : sharedClasses.inputField,
        className && className,
        disabled && classes.disabled,
        large && classes.large,
        compact && classes.compact,
        noPadding && classes.noPadding,
        value && classes.checked,
    ].filter((c) => c);

    useEffect(() => {
        if (reset) {
            onChange(false);
        }
    }, [reset]);

    return (
        <label
            className={classNamesList.join(" ")}
            htmlFor={name}
            style={style}
            onKeyDown={(e) => {
                // If enter is pressed, toggle check
                if (e.key === "Enter") {
                    onChange(!value);
                }
            }}
        >
            <input
                value={value}
                onChange={(e) => onChange(!value)} // Idk why, but when I use e.target.value, it's just throws only true or false ¯\_(ツ)_/¯
                disabled={disabled}
                name={name}
                id={name}
                className={classes.checkboxInput}
                type="checkbox"
            />
            <div className={classes.checkbox}>{value && <img src={Check} alt="Checkmark" />}</div>
            {image && (
                <img
                    src={image}
                    style={{
                        marginRight: "0.5rem",
                        border: "0.5px solid black",
                    }}
                    width="80"
                    alt="image multi select"
                />
            )}
            <div className={`${sharedClasses.label} ${classes.label} ${hideLabel ? "invisible" : ""}`} htmlFor={name}>
                {label}
            </div>
            {nonH2kParam && (
                <NonH2kParamTooltip className={`${classes.nonH2kParamTooltip}`} nonH2kParam={nonH2kParam} />
            )}
        </label>
    );
};
